import * as React from 'react';
import { useSelector } from 'react-redux';

import { FavouriteButton } from '../../components/FavouriteButton';
import { NewbuildingHeaderFullscreenGalleryHeader } from '../../components/NewbuildingHeaderFullscreenGalleryHeader';
import { getName } from '../../selectors/newbuildingHeader';
import { NewbuildingHeaderFavouriteButtonContainer } from '../NewbuildingHeaderFavouriteButton';
import { NewbuildingHeaderFullscreenGalleryCallContainer } from '../NewbuildingHeaderFullscreenGalleryCall';

export const NewbuildingFullscreenGalleryHeaderContainer: React.FC = () => {
  const newbuildingName = useSelector(getName);

  return (
    <NewbuildingHeaderFullscreenGalleryHeader
      newbuildingName={newbuildingName || ''}
      favourite={<NewbuildingHeaderFavouriteButtonContainer button={FavouriteButton} />}
      call={<NewbuildingHeaderFullscreenGalleryCallContainer />}
    />
  );
};
